import getAPIPath from '../../js/modules/api-location';
import { addNotification } from './notificationActions';

export function createCapsuleUser(values) {
  // https://developer.capsulecrm.com/v2/models/party
  const { firstName, lastName, emailAddress, areaNo1, areaCode1, telNo1, organisation, city, numberOfCoaches, information } = values;
  const body = {
    firstName,
    lastName,
    emailAddress,
    areaNo1,
    areaCode1, // We don't actually do anything with this on Capsule but there in case it needs adding in future
    telNo1,
    organisation: `${organisation} (RANGERS)`,
    city,
    numberOfCoaches,
    information,
  };

  return function(dispatch) {
    return fetch(`${getAPIPath}commandapi/c-crm/create-user`, {
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    // First promise
    .then(response => (
      // We need to return another promise in order to access the partyId
      response.json().then((res) => {
        dispatch(addNotification({
          message: 'Thanks for your enquiry. A member of our team will get back to you soon.',
          level: 'success',
          autoDismiss: 0,
        }));
        // As fetch returns a promise, if a successful API call is made we want to resolve the promise with the newly created
        // party id so we can use it to create a Capsule task
        return res.data.party.id;
      })
    ))
    .catch(() => {
      dispatch(addNotification({
        message: 'There was a problem with your submission. Please visit our <a href="/help-centre">Help Centre</a> for answers to frequently asked questions and contact details.',
        level: 'error',
        autoDismiss: 0,
      }));
    });
  };
}

const dueDate = () => {
  const today = new Date();
  today.setDate(today.getDate() + 2);
  return today.toISOString().split('T')[0];
};

export function createCapsuleTask(values, partyId) {
  // https://developer.capsulecrm.com/v2/operations/Task#createTask
  const { firstName, lastName } = values;
  const dueOn = dueDate();
  const body = {
    firstName,
    lastName,
    partyId,
    dueOn,
  };

  return fetch(`${getAPIPath}commandapi/c-crm/create-task`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
  // We don't need any success or error handling as failing to create a task in Capsule is not an issue for the user, only for us
}



// WEBPACK FOOTER //
// ./library/app/actions/capsuleActions.js